import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

import ItemCheckbox from './ItemCheckbox';

const RadioButton = styled.input`
  position: absolute;
  appearance: none;

  /* Checked */
  &:checked + ${ItemCheckbox} {
    position: relative;
    border-color: #fff;
    background-color: ${COLORS.primary};
    transition: border-color 0.25s ease-out, background-color 0.25s ease-out;

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: #fff;
    }
  }

  /* Focused */
  &:focus + ${ItemCheckbox} {
    outline: 5px auto ${COLORS.primary};
  }

  /* Disabled */
  &:disabled + ${ItemCheckbox} {
    opacity: 0.4;
  }
`;

export default RadioButton;
